import {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import ProjectModal from "../../../atoms/modals/projectModal";
import {useDispatch, useSelector} from "react-redux";
import {deleteProject, updateProjects} from "../../../../store/actions/creator/creatorDashboard";
import DotSidebar from "./dotSidebar";
import {IProject} from "../../../../store/reducers/creator/creatorDashboard";
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    zIndex: 1,
    width: 210,
    padding: '8px 8px 0 22px'
  },
  title: {
    marginTop: 16,
    fontFamily: 'Spartan-bold',
    fontSize: 20,
    color: '#017AEF',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  grey: {
    color: '#606B76'
  },
  projectsPanel: {
    height: '100%',
    maxHeight:350,
    overflow: 'auto'
  },
  projectTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    color: '#606B76'
  },
  projectCreateIcon: {
    cursor: 'pointer'
  },
  folder: {
    display: 'flex',
    alignItems: 'center',
    height: 35,
    cursor: 'pointer!important'
  },
  folderName: {
    fontSize: 14,
    fontFamily: 'roboto-bold',
    color: '#697683',
    margin: '0 0 0 8px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
}));

export default function Projects(props: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const {projects} = useSelector((state: any) => state.creatorDashboard);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [showModal, setShowModal] = useState(false);
  const [folderHover, setFolderHover] = useState(-1);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [batchAsyncRole, setBatchAsyncRole] = useState(false);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};

  useEffect(() => {
    if(loginUserData && loginUserData.role_access){
      if(loginUserData.role_access.length){
        const batch_async = loginUserData.role_access.filter((val:any) => val.access_name === "batch_async");
        if(batch_async.length > 0 && batch_async[0].access_value){
          setBatchAsyncRole(true)
        }
      }
    }
  }, [])

  const handleModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedIndex(-1);
    }, 500)
  };

  const projectRename = (index: number) => {
    setSelectedIndex(index);
    setShowModal(true);
  };

  const projectDelete = (index: number) => {
    const request = {
      projectId: projects[index].projectId
    };
    dispatch(deleteProject(apolloClient.client, request, index));
    onSelectProject(-1);
  };

  const handleDragEnd = (result: any) => {
    // return if item was dropped outside
    if (!result.destination) return;
    // return if the item was dropped in the same place
    if (
      result.source.droppableId === result.destination.droppableId &&
      result.source.index === result.destination.index
    ) return;
    // get the items array
    const newProjects = [...projects];
    // get the draggedItem
    const draggedItem = newProjects[result.source.index];
    // delete the item from source position and insert it to the destination position
    newProjects.splice(result.source.index, 1);
    newProjects.splice(result.destination.index, 0, draggedItem);
    // create new data
    const newData = [...newProjects];
    // update projects of store
    dispatch(updateProjects(newData));
  };

  const { onSelectProject, projectId, reelsLength } = props;

  const filterProjectsByReels = projects.filter((project: IProject) => !project.reels);

  return (
    <div className={classes.root}>

      <p
        className={clsx(classes.title, projectId !== -1 && classes.grey)} 
        onClick={() => onSelectProject(-1)}
      >
        All Experiences
      </p>
      <div className={classes.projectTitle}>
          <p>Projects</p>&nbsp;&nbsp;&nbsp;&nbsp;
          <img
            src={'/assets/icons/creatordashboard/project-add.svg'}
            alt={'img'}
            className={classes.projectCreateIcon}
            onClick={() => setShowModal(true)}
          />
        </div>
      <div className={classes.projectsPanel}>
        
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="Projects">
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {filterProjectsByReels.length > 0 && filterProjectsByReels.map((project: IProject, index: any) => (
                  <Draggable draggableId={String(index)} index={index} key={index}>
                    {(provided) => (
                      <div
                        className={classes.folder}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{...provided.draggableProps.style}}
                        onMouseOver={() => setFolderHover(index)}
                        onMouseLeave={() => setFolderHover(-1)}
                      >
                        <div 
                          className={classes.folder}
                          onClick={()=>onSelectProject(project.projectId)}
                          style={{width:"100%",maxWidth:"80%"}}
                        >
                          <img
                            alt={'img'}
                            src={`/assets/icons/creatordashboard/${(folderHover === index || projectId === project.projectId) ? 'folder-hover-icon.svg' : 'folder-icon.svg'}`}                          
                            />
                          <p
                            className={classes.folderName}
                            style={{
                              color: (folderHover === index || projectId === project.projectId) ? '#017AEF' : ''
                            }}
                          >
                            {project && project.projectName}
                          </p>
                        </div>
                        {folderHover === index && (
                          <DotSidebar
                            onRename={() => projectRename(index)}
                            onDelete={() => projectDelete(index)}
                          />
                        )}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
     {(batchAsyncRole && reelsLength > 0) && <p className={clsx(classes.title, projectId !== -2 && classes.grey)} onClick={()=>onSelectProject(-2)}>Reels</p>}
      <ProjectModal
        open={showModal}
        onClose={handleModal}
        selectedIndex={selectedIndex}
      />
    </div>
  );
}

